import { isFileAboveMaxSize } from 'ComponentLibrary/src/common/files'

export const MAX_PLAYGROUND_FILE_SIZE_BYTES = 20 * 1024 * 1024
export const PLAYGROUND_FILE_SIZE_ERROR_MESSAGE = 'Die Datei ist größer als 20 MB. Bitte PDF komprimieren und erneut versuchen.'

export const hasFileAboveMaxSize = (files: File[], maxFileSizeBytes = MAX_PLAYGROUND_FILE_SIZE_BYTES) =>
    files.some((file) => isFileAboveMaxSize(file, maxFileSizeBytes))
